import { Search, RefreshCw } from 'lucide-react'
import { Input, Button } from '@/components/ui'
import { useTranslation } from 'react-i18next'
import { formatDate } from '@/utils/format-date.util'

interface QRCodeSearchBarProps {
  searchTerm: string
  onSearchChange: (value: string) => void
  lastGeneratedAt?: Nullable<string>
  onRegenerateErrors: () => void
  isRegeneratingErrors: boolean
  showRegenerateErrors: boolean
}

export function QRCodeSearchBar({
  searchTerm,
  onSearchChange,
  lastGeneratedAt,
  onRegenerateErrors,
  isRegeneratingErrors,
  showRegenerateErrors,
}: QRCodeSearchBarProps) {
  const { t } = useTranslation()

  return (
    <div className='flex justify-between items-center mb-6'>
      <div>
        {lastGeneratedAt && (
          <p className='text-sm text-gray-600'>
            {t('qrCode.generatedOn')}{' '}
            <span className='font-bold'>{formatDate(lastGeneratedAt)}</span>
          </p>
        )}
      </div>

      <div className='flex items-center gap-4'>
        {showRegenerateErrors && (
          <Button
            variant='outline'
            className='flex items-center gap-2 border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800'
            onClick={onRegenerateErrors}
            disabled={isRegeneratingErrors}
          >
            <RefreshCw
              className={`h-4 w-4 ${isRegeneratingErrors ? 'animate-spin' : ''}`}
            />
            {t('qrCode.regenerateAll', 'Regenerate all')}
          </Button>
        )}

        <div className='relative w-64'>
          <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400' />
          <Input
            placeholder={t('qrCode.searchPlaceholder')}
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            className='pl-10'
          />
        </div>
      </div>
    </div>
  )
}
